import React from "react";
import Card from "react-bootstrap/Card";

function ProjectCards({ imgPath, title, description, link, date, type }) {
  const Wrapper = ({ children }) =>
    link ? (
      <a
        href={link}
        target="_blank"
        rel="noreferrer"
        style={{
          textDecoration: "none",
          color: "inherit",
          display: "block",
          height: "100%",
        }}
      >
        {children}
      </a>
    ) : (
      children
    );

  return (
    <Wrapper>
      <Card
        className="project-card-view"
        style={{
          cursor: link ? "pointer" : "default",
          height: "100%",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Card.Img variant="top" src={imgPath} alt={title} />

        <Card.Body
          style={{
            display: "flex",
            flexDirection: "column",
            flexGrow: 1,
          }}
        >
          <Card.Title>{title}</Card.Title>

          <Card.Text style={{ textAlign: "justify", flexGrow: 1 }}>
            {description}
          </Card.Text>

          {/* Bottom row */}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              fontSize: "0.85rem",
              opacity: 0.8,
              marginTop: "10px",
            }}
          >
            <span>{type}</span>
            <span>{date}</span>
          </div>
        </Card.Body>
      </Card>
    </Wrapper>
  );
}

export default ProjectCards;
